import type { QuickFilterGroup } from '@/features/filter/quick-filter/quick-filter-service';

import { useFilterDataV1Mutation } from '@/features/filter/filter-data/use-filter-data-mutation';

export default function useQuickFilter() {
    const { toggleFilter } = useFilterDataV1Mutation();
    const deselectFilterGroup = (group: QuickFilterGroup) => {
        if (group.hasSelectedFilterOptions) {
            toggleFilter({
                groupName: group.name,
                isDeactivated: false,
                isDefault: false,
                isQuickFilterDeselect: true,
                isSelected: true,
                optionNames: group.selectedFilterOptions,
                type: 'deselect',
            });
        }
    };
    return { deselectFilterGroup };
}
